import { useState, useEffect } from 'react';
import api from '../config/axiosConfig';

const useJourneyProgress = () => {
  const [hasAcceptedQuotation, setHasAcceptedQuotation] = useState(false);
  const [hasCompletedInfo, setHasCompletedInfo] = useState(false);
  const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkProgress();
  }, []);

  const checkProgress = async () => {
    try {
      // Verificar servicios autorizados
      try {
        const quotationsResponse = await api.get('/quotations');
        const quotations = quotationsResponse.data;
        const hasAccepted = quotations.some(q => q.status === 'ACCEPTED');
        setHasAcceptedQuotation(hasAccepted);
      } catch (error) {
        console.error('Error verificando cotizaciones:', error);
      }
      
      // Verificar si la información de la empresa está completa
      try {
        const userResponse = await api.get('/users/me');
        const company = userResponse.data?.company;
        
        if (company) {
          const isInfoComplete = !!(
            company.businessName &&
            company.rfc &&
            company.legalName &&
            company.businessSector &&
            company.street &&
            company.exteriorNumber &&
            company.neighborhood &&
            company.municipality &&
            company.state &&
            company.postalCode &&
            company.fiscalStreet &&
            company.fiscalExteriorNumber &&
            company.fiscalNeighborhood &&
            company.fiscalMunicipality &&
            company.fiscalState &&
            company.fiscalPostalCode &&
            company.fiscalCountry &&
            company.corporateContactTitle &&
            company.corporateContactFirstName &&
            company.corporateContactPaternalSurname &&
            company.corporateContactMaternalSurname &&
            company.corporateContactEmail &&
            company.corporateContactPhone &&
            company.legalRepresentative
          );
          
          setHasCompletedInfo(isInfoComplete);
        }
      } catch (error) {
        console.error('Error verificando información de empresa:', error);
      }
      
      // TODO: Verificar archivos subidos cuando se implemente
      // setHasUploadedFiles(hasFiles);
      
      setLoading(false);
    } catch (error) {
      console.error('Error verificando progreso:', error);
      setLoading(false);
    }
  };

  return {
    hasAcceptedQuotation,
    hasCompletedInfo,
    hasUploadedFiles,
    loading,
    refresh: checkProgress
  };
};

export default useJourneyProgress;
